import React from "react";
import { ArrowRightIcon, PlusIcon } from "lucide-react";
import { useLanguage } from "../../i18n/LanguageContext";
import { images } from "../../i18n/translations";
import { SectionHeading } from "../ui/SectionHeading";
import { Reveal } from "../ui/Reveal";
export function Products() {
  const {
    t
  } = useLanguage();
  return <section id="productos" className="w-full bg-slate-50 py-20 sm:py-28" data-id="element-193" data-mp="24lcpk6u3041f">
      <div className="max-w-content mx-auto px-4 sm:px-6" data-id="element-194" data-mp="16z71l2lwrvob">
        <SectionHeading eyebrow={t.products.eyebrow} title={t.products.title} subtitle={t.products.subtitle} data-id="element-195" data-mp="1bx8ndvapy93h" />

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-196" data-mp="1gviiy70cvbpm">
          {t.products.items.map((p, i) => <Reveal key={p.name} delay={i % 3 * 0.06} data-id="element-197" data-mp="1lwpm1srjzmpy" data-mpi={i}>
              <article className="group h-full bg-white rounded-sm overflow-hidden border border-slate-200 shadow-sm transition-all duration-300 hover:shadow-xl hover:-translate-y-1" data-id="element-198" data-mp="2sc9swv7t9t12">
                <div className="relative h-52 overflow-hidden" data-id="element-199" data-mp="b9rwtdqkr4ai">
                  <img src={images.products[i]} alt={p.name} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-200" data-mp="b75m558e08o2" />
                  <span className="absolute top-3 left-3 bg-navy/90 text-white text-xs font-semibold uppercase tracking-wide px-2.5 py-1 rounded-sm" data-id="element-201" data-mp="3ted0lnf0ubw5">
                    {p.name}
                  </span>
                </div>
                <div className="p-6" data-id="element-202" data-mp="3jmyv8z0e2hv3">
                  <h3 className="font-heading font-bold uppercase text-navy text-2xl" data-id="element-203" data-mp="3epgv9y4cncz8">{p.name}</h3>
                  <p className="mt-2 text-sm text-slate-600 leading-relaxed" data-id="element-204" data-mp="3aowwkq44o1az">{p.desc}</p>
                  <a href="#contacto" className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-orange hover:text-orange-dark" data-id="element-205" data-mp="35p0tct398dwh">
                    {t.products.cta}
                    <ArrowRightIcon size={16} data-id="element-206" data-mp="2r10gq0to3gmb" />
                  </a>
                </div>
              </article>
            </Reveal>)}

          {/* "Y más" card */}
          <Reveal delay={0.06} data-id="element-207" data-mp="2h573sgc1dl40">
            <a href="#contacto" className="group flex h-full min-h-[300px] flex-col items-center justify-center rounded-sm border-2 border-dashed border-navy/25 bg-navy/[0.03] p-8 text-center transition-colors hover:border-orange hover:bg-orange/5" data-id="element-208" data-mp="2h68jiy3zyvs2">
              <span className="flex h-14 w-14 items-center justify-center rounded-full bg-navy text-orange transition-colors group-hover:bg-orange group-hover:text-white" data-id="element-209" data-mp="3ermr3yr59czh">
                <PlusIcon size={28} data-id="element-210" data-mp="351b8d62swz8j" />
              </span>
              <h3 className="mt-4 font-heading font-bold uppercase text-navy text-2xl" data-id="element-211" data-mp="35008hhch8bmp">
                {t.products.more}
              </h3>
              <p className="mt-2 text-sm text-slate-600 max-w-[240px]" data-id="element-212" data-mp="1eb8acdawkje">{t.products.moreDesc}</p>
            </a>
          </Reveal>
        </div>
      </div>
    </section>;
}